export default __webpack_public_path__ + "static/media/grafema_2ndliferesin_12.d2157026.jpg";